import { render } from "./SignIn.vue?vue&type=template&id=b17daada"
import script from "./SignIn.vue?vue&type=script&lang=ts"
export * from "./SignIn.vue?vue&type=script&lang=ts"
script.render = render

export default script